import { gql } from '@apollo/client/core';

export const updateControllerNote = gql`
  mutation updateControllerNote(
    $id: String
    $input: UpdateControllerNoteInput
  ) {
    updateControllerNote(id: $id, input: $input) {
      id
    }
  }
`;
